import React from "react";
import { STPaper } from "@src/Components/Ui/STPaperOverflow";
import { Table, TableHead, TableCell, TableRow, TableBody } from "@material-ui/core";
import { STTableHeadTypography } from "@src/Components/Ui/STTableHeadTypography";
import { Values } from "@src/Tools/Values";
import ApplicationTableItem from "./ApplicationTableItem/ApplicationTableItem";
import { ApplicationLink } from "@src/Interfaces/Entity/ApplicationLink";

interface IProps {
  applications: ApplicationLink[];
}

export default class ApplicationLinkTable extends React.Component<IProps> {
  render() {
    return (
      <STPaper elevation={2}>
        <Table>
          <colgroup>
            <col width="20%" />
            <col width="25%" />
            <col width="25%" />
            <col width="10%" />
            <col width="10%" />
            <col width="10%" />
          </colgroup>
          <TableHead>
            <TableRow>
              <TableCell>
                <STTableHeadTypography>{Values.getLocalizationValue("name")}</STTableHeadTypography>
              </TableCell>
              <TableCell>
                <STTableHeadTypography>{Values.getLocalizationValue("description")}</STTableHeadTypography>
              </TableCell>
              <TableCell>
                <STTableHeadTypography>{Values.getLocalizationValue("uRL")}</STTableHeadTypography>
              </TableCell>
              <TableCell align="center">
                <STTableHeadTypography>{Values.getLocalizationValue("mobile")}</STTableHeadTypography>
              </TableCell>
              <TableCell align="center">
                <STTableHeadTypography>{Values.getLocalizationValue("desktop")}</STTableHeadTypography>
              </TableCell>
              <TableCell align="right" />
            </TableRow>
          </TableHead>
          <TableBody>
            {this.props.applications.map((application: ApplicationLink) => {
              return <ApplicationTableItem key={application.id} application={application} />;
            })}
          </TableBody>
        </Table>
      </STPaper>
    );
  }
}
